export interface IBookingSortTypes {
  createdDate: string;
  checkinDate: string;
  checkoutDate: string;
}

export const BookingSortTypes: IBookingSortTypes = {
  createdDate: "created_date",
  checkinDate: "checkin_date",
  checkoutDate: "checkout_date",
};
